import MarkdownPage from "@/components/MarkdownPage";

export default function Contact() {
  return (
    <MarkdownPage
      sourcePath="/legal/contact-us.md"
      title="Contact Pathvio"
      description="Get in touch with the Pathvio team for support, billing, partnerships, or feedback."
    />
  );
}
